<section
  class="profile-app-page-container"
  [ngClass]="{'tabs-hidden': isSaasEnabledProvider()}"
>
  @if (!isSaasEnabledProvider()) {
    <iris-tab
      class="nav-bar"
      [tabItems]="tabItems"
      [stretchTabs]="true"
      [exactRoute]="true">
    </iris-tab>
  }

  <div class="page-content">
    @if (!isSaasEnabledProvider()) {  
      <member-profile-submit></member-profile-submit>
    }
    
    <router-outlet></router-outlet>

    @if (!isSaasEnabledProvider()) {  
      <potential-clients-view-card></potential-clients-view-card>
    }
  </div>
</section>
